import { render, staticRenderFns } from "./trocarSenha.vue?vue&type=template&id=155b5628"
import script from "./trocarSenha.vue?vue&type=script&lang=js"
export * from "./trocarSenha.vue?vue&type=script&lang=js"
import style0 from "./trocarSenha.vue?vue&type=style&index=0&id=155b5628&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports